<template>
    <div class="login-form">
        <div class="tabsChange">
            <div @click="changeShow(1)" :class="{active:show === 1}">账号登录</div>
            <div @click="changeShow(3)" :class="{active:show === 3}">手机号登录</div>
            <div @click="changeShow(2)" :class="{active:show === 2}">证书(锁)登录</div>
        </div>
        <el-form v-if="show === 1" :model="dataForm" :rules="dataRule" ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()"
                 status-icon>
            <ul class="login-ul">
                <li class="login-li radius3">
                    <!-- <i class="login-user"></i> -->
                    <el-form-item prop="userName">
                      <el-input v-model.trim="dataForm.userName" clearable placeholder="请输入账号/用户名">
                        <img class="prefixImageStyle" slot="prefix" src="../../assets/images/icon-login-user.png" />
                      </el-input>
                    </el-form-item>
                </li>
                <li class="login-li radius3">
                    <!-- <i class="login-pwd"></i> -->
                    <el-form-item prop="password">
                        <el-tooltip v-model="capsTooltip" content="已开启大写" placement="top" manual>
                            <el-input v-model.trim="dataForm.password"   @keyup.native="checkCapslock" clearable type="password" placeholder="请输入密码" show-password>
                              <img class="prefixImageStyle" slot="prefix" src="../../assets/images/icon-lock-on.png" />
                            </el-input>
                        </el-tooltip>
                    </el-form-item>
                </li>
                <li class="captcha-box" v-if="hasCaptcha">
                    <el-form-item prop="captcha">
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <el-input v-model="dataForm.captcha" clearable placeholder="验证码">
                                </el-input>
                            </el-col>
                            <el-col :span="8" class="login-captcha">
                                <img :src="captchaPath" @click="getCaptcha()" alt="">
                            </el-col>
                        </el-row>
                    </el-form-item>
                </li>
                <!--<li>-->
                <!--<router-link to="/forget"><span class="blue-back">忘记密码?</span></router-link>-->
                <!--</li>-->
                <li>
                    <el-form-item>
                        <el-button class="login-btn radius3" style="padding: 0px 0px;margin-top:8px;" type="primary"
                                   @click="dataFormSubmit()">登 录
                        </el-button>
                    </el-form-item>
                </li>
            </ul>
        </el-form>
        <el-form v-if="show === 3" :model="dataForm" :rules="dataRule" ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()"
                 status-icon>
            <ul class="login-ul phone">
                <li class="login-li">
                    <el-form-item prop="phone">
                        <el-input v-model.trim="dataForm.phone" clearable placeholder="请输入手机号">
                          <img class="prefixImageStyle" slot="prefix" src="../../assets/images/icon-mobile.png" />
                        </el-input>
                    </el-form-item>
                </li>
                <li class="login-li">
                    <el-form-item prop="phoneCaptcha">
                        <el-row :span="24">
                            <el-col :span="24">
                                <el-input v-model.trim="dataForm.phoneCaptcha" clearable placeholder="请输入验证码">
                                    <img class="prefixImageStyle" slot="prefix" src="../../assets/images/icon-secured.png" />
                                    <template slot="suffix">
                                        <el-button  v-if="showTime" type="info"  class="phoneCaptcha_gray">{{time}} s</el-button>
                                        <el-button type="text" v-else class="phoneCaptcha" @click="sendMsg">发送验证码</el-button>
                                    </template>
                                </el-input>
                            </el-col>
                        </el-row>
  
  
                    </el-form-item>
                </li>
                <li class="captcha-box" v-if="hasCaptcha">
                    <el-form-item prop="captcha">
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <el-input v-model="dataForm.captcha" placeholder="验证码">
                                </el-input>
                            </el-col>
                            <el-col :span="8" class="login-captcha">
                                <img :src="captchaPath" @click="getCaptcha()" alt="">
                            </el-col>
                        </el-row>
                    </el-form-item>
                </li>
                <!--<li>-->
                <!--<router-link to="/forget"><span class="blue-back">忘记密码?</span></router-link>-->
                <!--</li>-->
                <li>
                    <el-form-item>
                        <el-button class="login-btn radius3" style="padding: 0px 0px;margin-top:8px;" type="primary"
                                   @click="dataFormSubmit()">登 录
                        </el-button>
                    </el-form-item>
                </li>
            </ul>
        </el-form>
        <div class="lock-box" v-if="show === 2">
            <div class="lock"></div>
            <p class="sizi">
                请插入CA锁确认插入后点击登录
            </p>
            <el-button class="login-btn radius3" style="padding: 0px 0px;" type="primary"
                       @click="caLoginClick">登 录
            </el-button>
        </div>
  
    </div>
  </template>
  <script>
    import {getUUID,setSessionStorage,aesEncrypt} from '@/utils';
    import {getZjca, ZjCaInfo, ZjSignData} from "@/plugin/caCommon/index";
    import {isMobile} from '@/utils/validate';
    import axios from 'axios';
    import{sendcaptcha,loadApp,login} from '@/server/login';
    const ssoHttp = axios.create({
        timeout: 1000 * 30,
        withCredentials: true,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X_PROXY_GATEWAY':true,
            'Content-Type': 'application/json; charset=utf-8'
        }
    })
  
    export default {
        data() {
            return {
                hasCaptcha: false,
                show: 1,
                loading:false,
                capsTooltip: false,
                dialogVisible: false,
                dataForm: {
                    userName: '',
                    password: '',
                    uuid: '',
                    captcha: '',
                    phone:'',
                    phoneCaptcha:''
                },
                dataRule: {
                    userName: [
                        {required: true, message: '账号不能为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ],
                    captcha: [
                        {required: true, message: '验证码不能为空', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入正确的手机号', trigger: 'blur',validator:isMobile}
                    ],
                    phoneCaptcha: [
                        {required: true, message: '请输入正确的验证码', trigger: 'blur'}
                    ]
                },
                captchaPath: '',
                time:59,
                showTime:false,
                timer:null
            }
        },
        created() {
            if(this.hasCaptcha){
                this.getCaptcha()
            }else{

                ssoHttp.get( ssoBaseUrl + '/hasCaptcha', {}).then(({data}) => {
                    if (data && data.code === '1' && data.data==true) {
                        this.getCaptcha()
                    }
                })

            }
        },

        methods: {
            async caLoginClick(){
                await this.getCA()
                await this.caLogin()
            },
            getCA() {

                getZjca((isEnv) => {
                    if (!isEnv) {
                        this.$alert(
                            "请查看CA助手，检查CA证书是否已正确安装在电脑上",
                            "提示",
                            {confirmButtonText: "确定"}
                        );
                    }
                });
                ZjCaInfo((caInfo) => {
                    this.dataForm.appId = this.settings.appId;
                    this.dataForm.backUrl =  '';
                    this.dataForm.loginType =  1;
                    this.dataForm.certName = caInfo.certName;
                    this.dataForm.appCode =  window.SITE_CONFIG.appCode;
                    this.dataForm.caCode =  caInfo.certserial;
                    this.dataForm.originData = caInfo.random;
                    this.dataForm.signCert = caInfo.base64cert;
                    this.dataForm.signdata = ZjSignData();
                    this.dataForm.username = "ca";
                    this.dataForm.password = "ca";
                });


            },
            caLogin(){

                login(this.dataForm).then((res) => {

                    let data=res.data;
                    if (data && data.code == '1') {

                        let caInfo = {
                            caCode: this.dataForm.caCode,
                            signData: this.dataForm.signData,
                            signCert: this.dataForm.signCert,
                            originData: this.dataForm.originData,
                        };
                        setSessionStorage("caInfo", caInfo);
                        this.$cookie.set('access_token', data.authCode);
                        this.$cookie.set('oauth_access_token', data.authCode);
                        this.initMenuList(()=>{
                            this.$router.push({ name: 'home' })
                        })


                 } else {
                        this.getCaptcha();
                        this.$message.error(data.msg)
                    }
                })
            },
            // 提交表单
            dataFormSubmit() {

                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        var data={
                            'backUrl': '',
                            'loginType': 0,
                            'useCaptcha': 1,
                            'appCode': window.SITE_CONFIG.appCode,
                            'username': this.dataForm.userName,
                            'password': aesEncrypt(this.dataForm.password),
                            'uuid': this.dataForm.uuid,
                            'captcha': this.dataForm.captcha,
                            'phone':this.dataForm.phone,

                        };
                        if(this.show==3){
                            data.username=this.dataForm.phone;
                            data.password=aesEncrypt(this.dataForm.phoneCaptcha);
                            data.loginType=6;
                        }
                        this.loading = true;
                        login(data).then((res) => {
                            data=res.data;
                            this.loading = false;
                            if (data && data.code == '1') {
                                this.$cookie.set('access_token', data.authCode);
                                this.$cookie.set('oauth_access_token', data.authCode);
                                // this.loginByJwt(data.authCode,()=>{
                                this.initMenuList(()=>{
                                    this.$router.push({ name: 'home' })
                                })
                                // })

                            }else if (data && data.code == '1099') {
                                this.$message.error(data.msg);
                                setTimeout(()=>{
                                    window.location.href = data.data + '&redirect_url=' + window.location.href;
                                },1000)
                            } else {
                                this.getCaptcha();
                                this.$message.error(data.msg)
                            }
                        }).catch(()=>{
                            this.loading = false;
                        })
                    }
                })
            },
            // 获取验证码
            getCaptcha() {
                this.hasCaptcha=true
                this.dataForm.uuid = getUUID()
                this.captchaPath = ssoBaseUrl + `/captchaCode.png?uuid=${this.dataForm.uuid}`
            },
            // 开启大写提示
            checkCapslock({ shiftKey, key } = {}) {
                if (key && key.length === 1) {
                    if (
                        (shiftKey && key >= "a" && key <= "z") ||
                        (!shiftKey && key >= "A" && key <= "Z")
                    ) {
                        this.capsTooltip = true;
                    } else {
                        this.capsTooltip = false;
                    }
                }
                if (key === "CapsLock" && this.capsTooltip === true) {
                    this.capsTooltip = false;
                }
            },
            // loginByJwt(token, callback) {
            //
            //     this.$httpReq.post('/oauth/tokenLogin?token=' + token, {
            //         token: token
            //     }).then(({data}) => {
            //         if (data.code === '1') {
            //             if(callback){
            //               callback()
            //             }
            //             return
            //
            //             let url = this.$route.query.redirect_uri
            //             if (url) {
            //                 // 由于ajax调用，不能回退到原来地址.
            //                 this.$router.push({name: 'home'})
            //             } else {
            //                 this.$router.push({name: 'home'})
            //             }
            //
            //
            //         } else {
            //             this.$message.error(data.msg)
            //         }
            //     })
            // },
            open() {
                this.$prompt('请输入口令', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    return;
                }).catch(() => {
                });
            },
            sendMsg(){//发送短信
                if(!this.dataForm.phone){
                    this.$message.error('请输入手机号！')
                }
                sendcaptcha({phone:this.dataForm.phone}).then(({data}) => {
                    if (data.code === '1') {
                        this.showTime=true;
                        this.timer=setInterval(()=>{
                            this.time=this.time-1;
                            if(this.time==0){
                                clearInterval(this.timer);
                                this.time=59;
                                this.showTime=false;
                            }
                        },1000)
                        // this.$message.success(data.msg)
                        this.$message.success('短信发送成功！')

                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            changeShow(type){
                this.show=type;
                if( type != 2){
                    this.$nextTick(()=> {
                        this.$refs['dataForm'].resetFields();
                    });
                }
                Object.assign(this.$data.dataForm, this.$options.data().dataForm);

            }
        },
        beforeDestroy(){
            if(this.timer){
                this.time=59;
                clearInterval(this.timer)
            }
        }
    }
  </script>
  
  <style lang="scss" scoped>
  .login-form{
      /deep/.el-input__inner{
          height: 48px;
          font-size: 16px !important;
          padding-left: 40px;
      }
      /deep/.el-form-item{
          margin-bottom: 30px;
      }
  }
    .tabsChange{
        color: rgba(255, 255, 255, 0.85);
        font-size: 18px;
        font-weight: 400;
        display: flex;
        justify-content: space-around;
        line-height: 46px;
        border-bottom: none !important;
        margin-bottom: 48px;
        &>div{
            padding:0 15px;
        }
        .active{
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border-bottom: 2px solid rgb(255, 255, 255) !important
        }
    }
    .phone{
        .inputTitle{
            font-size: 18px;
            line-height: 30px;
            color: #a2a2a2;
        }
        .el-button.phoneCaptcha{
            height: 48px !important;
            line-height: 30px !important;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.45) !important;
            background-color: transparent !important;
            margin-top: 0px;
            padding:0;
            &:hover {
              background: transparent;
            }
        }
        .el-button.phoneCaptcha_gray{
            height: 30px !important;
            line-height: 30px !important;
            font-size: 14px;
            color: #fff;
            margin-top: 0px;
            padding:0;
        }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition-delay: 111111s;
        -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
    }
    .container .centerRight .login-form .login-li .el-input__inner{
        padding-left:8px;
    }
  </style>